<template>
  <div class="grid grid-cols-2 gap-2.5">
    <AttrInputNumber
      class=""
      :value="shape.attrs['fontSize']"
      label="字号"
      :min="1"
      :max="500"
      :width="54"
      :disabled="!!attrDisabled"
      :precision="0"
      selection
      :options="fontSizeOptions"
      @change="(val:any)=> shape.setAttrs({'fontSize':val })"
    />
    <AttrInputNumber
      class=""
      :value="shape.attrs['letterSpace'] ?? 0"
      label="|A|"
      :min="canUse('letter-space-negative').valid ? -999 : 0"
      addon-after="px"
      :precision="0"
      :disabled="!!attrDisabled"
      @change="(val:any)=> shape.setAttrs({ 'letterSpace':val})"
    />
  </div>
</template>
<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { canUse } from '@/utils/can-use.utils';
import { PropType, computed } from 'vue';
defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});

const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const fontSizeOptions = computed(() => {
  let sizes = [
    10, 11, 12, 13, 14, 15, 16, 18, 20, 24, 32, 36, 40, 48, 64, 96, 128
  ];

  // 18号字体仅特定设备可用
  if (!canUse('text-font-size-18').valid) {
    sizes = sizes.filter((s) => s !== 18);
  }

  return sizes.map((item) => ({
    label: item + '',
    value: item
  }));
});
</script>

<style lang="less" scoped></style>
